import React from 'react';
import { Download, Plus } from 'lucide-react';
interface PageHeaderProps {
  title: string;
  subtitle: string;
  primaryAction?: {
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
  };
}
const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  primaryAction,
  secondaryAction
}) => {
  return <div className="mb-6 flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-3 sm:space-y-0" data-id="element-986">
      <div data-id="element-987">
        <h1 className="text-2xl font-bold" data-id="element-988">{title}</h1>
        <p className="text-sm text-gray-500" data-id="element-989">{subtitle}</p>
      </div>
      <div className="flex flex-wrap gap-2" data-id="element-990">
        {secondaryAction && <button onClick={secondaryAction.onClick} className="flex items-center rounded-full border border-gray-300 px-4 py-2 text-sm hover:bg-gray-50 transition-colors" data-id="element-991">
            {secondaryAction.icon}
            {secondaryAction.label}
          </button>}
        {primaryAction && <button onClick={primaryAction.onClick} className="flex items-center rounded-full bg-greenback text-white px-4 py-2 text-sm hover:bg-greenback-600 transition-colors" data-id="element-992">
            {primaryAction.icon}
            {primaryAction.label}
          </button>}
      </div>
    </div>;
};
export default PageHeader;